export default __webpack_public_path__ + "images/0xcabae6f6ea1ecab08ad02fe02ce9a44f09aebfa2.png";